<template>
<div class="article-summary-list">
    <div class="content-container" :class="[pageConfigLayoutStyle?.ARTICLE_PAGE_WIDE_LAYOUT === pageLayoutStyle ? 'article-summary-list-wide':'article-summary-list-narrow' ]">
        <p class="paragraph-two">
            <strong>
                A {{ validatedTimeEstimate }}-minute read. In this article, you’ll learn about:
            </strong>
        </p>

        <div class="list-container content-block">
            <ul>
                <li v-for="i in bulletPoints.length" :key="i">
                    {{ bulletPoints[i - 1] }}
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "ArticleSummaryList",
    props: {
        bulletPointsString: String,
        timeEstimate: {
            type: Number
        },
        pageLayoutStyle: String
    },
    computed: {
        bulletPoints() {
            if (this.bulletPointsString.trim() === "" || this.bulletPointsString == null) {
                return [];
            }

            return this.bulletPointsString.trim().split("\n");
        },
        validatedTimeEstimate() {
            let timeEstimate = typeof this.timeEstimate == "number"
                ? Math.max(this.timeEstimate, 0)
                : 0;
            return timeEstimate;
        }
    }
}
</script>

<style lang="scss" scoped>
.article-summary-list {
    background-color: $grayscale-seven;

     .article-summary-list-narrow {
        max-width: $narrower-page-width-padded;
    }

    .article-summary-list-wide {
        max-width: $page-width-padded;

    }
    .content-container {
        padding: $spacer-five $page-padding;
        margin: auto;
    }

    .list-container {
        margin-right: $spacer-five;

        ul {
            display: flex;
            flex-wrap: wrap;

            li {
                flex-basis: 50%;
            }
        }
    }

    @include tablet {
        .list-container {
            padding-top: $spacer-three;

            ul {
                li {
                    &:nth-last-child(2) {
                        padding-bottom: 0;
                    }
                }
            }
        }
    }

    @include wide-mobile {
        .list-container {
            ul {
                flex-direction: column;
            }
        }
    }
}
</style>
